module.exports = __webpack_public_path__ + "static/media/16.8fd74734.wav";